import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { canRecoverAutomatically, isAssetLoadError, recoverFromStaleAssets } from "../staleAssetsRecovery"

export const useErrorFallback = (error: Error) => {
  // No suspense: this screen must render even when the translation chunks are the ones failing.
  const { t } = useTranslation("app", { useSuspense: false })
  const [{ shouldRecoverAutomatically, isStillFailing }] = useState(() => {
    const hasRecoveredRecently = !canRecoverAutomatically()
    return {
      shouldRecoverAutomatically: isAssetLoadError(error) && !hasRecoveredRecently,
      isStillFailing: hasRecoveredRecently,
    }
  })
  const [isRecovering, setIsRecovering] = useState(shouldRecoverAutomatically)

  useEffect(() => {
    if (shouldRecoverAutomatically) {
      void recoverFromStaleAssets()
    }
  }, [shouldRecoverAutomatically])

  const reload = () => {
    setIsRecovering(true)
    void recoverFromStaleAssets()
  }

  return { t, isRecovering, isStillFailing, reload }
}
